import { Helmet } from "react-helmet-async";

const SITE_URL = "https://fitprintbros.com";
const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1581079289196-67865ea83118?w=1200&h=630&fit=crop";

export const SEO = ({ title, description, path = "/", image, type = "website", jsonLd }) => {
  const fullTitle = title ? `${title} | Fit Print Bros` : "Fit Print Bros | Custom Printing & Embroidery";
  const desc = description || "Professional screen printing, DTF, embroidery, and design services. Smart artwork analysis, transparent pricing, and fast turnaround.";
  const url = `${SITE_URL}${path}`;
  const img = image || DEFAULT_IMAGE;

  // Default Organization JSON-LD
  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Fit Print Bros",
    "url": SITE_URL,
    "logo": `${SITE_URL}/logo192.png`,
    "description": "Professional screen printing, DTF, embroidery, and custom design services",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": "English"
    },
    "sameAs": []
  };

  // WebSite schema for search
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Fit Print Bros",
    "url": SITE_URL,
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${SITE_URL}/products?q={search_term_string}`,
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content="Fit Print Bros" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {/* JSON-LD: Organization (always present) */}
      {path === "/" && (
        <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      )}
      {path === "/" && (
        <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      )}

      {/* Page-specific JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
